module.exports = __webpack_public_path__ + "img/service3.499dc7f9.png";